var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"documents",staticClass:"documents"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('file-list',{attrs:{"height":_vm.height,"viewer":_vm.viewer,"form":_vm.form,"selectable":_vm.selectable,"has-chart":""}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8a6aa60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Documents/list/index.vue
// module id = null
// module chunks = 